/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Job_Type_LabelInputs */

const en_candidate_profile_job_type_label = /** @type {(inputs: Candidate_Profile_Job_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired Job Type`)
};

const de_candidate_profile_job_type_label = /** @type {(inputs: Candidate_Profile_Job_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewünschte Anstellungsart`)
};

/**
* | output |
* | --- |
* | "Desired Job Type" |
*
* @param {Candidate_Profile_Job_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_job_type_label = /** @type {((inputs?: Candidate_Profile_Job_Type_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Job_Type_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_job_type_label(inputs)
	return en_candidate_profile_job_type_label(inputs)
});